"use client";

import { Suspense } from "react";

import { DepictFilter, DepictSort } from "@/lib/hooks/useProductFilter/types";
import FilterModal from "./Filter";
import SortModal from "./Sort";

const PlpModals = ({
  filters,
  search,
  sort,
}: {
  filters: DepictFilter[];
  search: string;
  sort: DepictSort[];
}) => {
  return (
    <>
      <Suspense fallback="...">
        <FilterModal filters={filters} />
        <SortModal sortOrder={sort} />
      </Suspense>
    </>
  );
};

export default PlpModals;
